// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aYoRFL5C7gocBQg0JmTs {

    margin-top: 0.75rem;

    display: flex;

    height: auto;

    width: 100%;

    flex-direction: column;

    gap: 1.25rem;

    font-family: Noto Sans
}

.Ida6mZxvJvkKDdzGsDTl {

    display: flex;

    width: 100%;

    flex-direction: column;

    gap: 0.75rem;

    border-radius: 0.375rem;

    --tw-bg-opacity: 1;

    background-color: rgb(242 250 254 / var(--tw-bg-opacity, 1));

    padding: 1rem
}

.m9jTYkAItI0R3dU3fS6G {

    display: flex;

    width: 100%;

    justify-content: space-between
}

.bmKQY5awTkVxI80Zu8VV {

    display: flex;

    width: 100%;

    justify-content: space-between;

    font-weight: 700
}

.L5cr5aRDE8NYP_QQxkcx {

    display: flex;

    width: 100%;

    justify-content: space-between
}

.wlnrCc3wcG8WItPDKjzz {

    font-family: Noto Sans;

    font-size: 1rem;

    line-height: 1.5rem;

    font-weight: 600
}

.eQh_KBPSRVJDMA1wr4bE {

    margin-bottom: 0.75rem;

    height: auto;

    width: 100%;

    border-radius: 0.5rem;

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));

    padding: 1rem
}
.pCt8gVJchyqDAMdyX1kq {

    margin-bottom: 0.75rem;

    height: auto;

    width: 100%;

    border-radius: 0.5rem;

    --tw-bg-opacity: 1;

    background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));

    padding: 1rem
}
.MUJy4XmvKUhygJ6iLTzF {

    display: flex;

    width: 100%;

    justify-content: space-between
}
.iyayL373quYP3YslNWI6 {

    font-family: Noto Sans;

    font-size: 14px;

    font-weight: 600
}
.ywNJQVILqqkh68CPccRw {

    cursor: pointer;

    font-family: Noto Sans;

    font-size: 12px;

    font-weight: 700;

    --tw-text-opacity: 1;

    color: rgb(3 120 209 / var(--tw-text-opacity, 1));

    text-decoration-line: underline
}
.nouZNe_v1gyilK5zOPhD {

    margin-top: 0.5rem;

    display: flex;

    height: auto;

    width: 100%;

    align-items: center
}
.RvHPUPYhgpKk4WlIe6GY {

    margin-top: 0.5rem;

    font-size: 12px
}

.SRaMHY09hKwjguq7dhk6 {

    display: flex;

    width: 100%;

    align-items: center;

    justify-content: center;

    gap: 1rem
}

.jAOe8I01FsTd0uc0mTno {

    height: 38px;

    width: 180px;

    --tw-bg-opacity: 1;

    background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));

    padding-left: 1.5rem;

    padding-right: 1.5rem;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.jAOe8I01FsTd0uc0mTno:hover {

    --tw-bg-opacity: 1 !important;

    background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;

    --tw-text-opacity: 1 !important;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}

.A2oeKMjFCuN9sRNS1FWK {

    margin-top: 1.5rem;

    display: flex;

    height: auto;

    width: 100%;

    flex-direction: column;

    gap: 1rem
}

.uE8FmmiJZW0UscC4o2ak {

    height: 132px;

    width: 100%;

    border-radius: 0.5rem;

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));

    padding: 1rem;

    font-family: Noto Sans;

    --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);

    --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);

    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.dNbE7FPgr0dyL02Spilg {

    font-family: Noto Sans;

    font-size: 1.125rem;

    line-height: 1.75rem;

    font-weight: 600
}

.qsbAhlD5PeP6MgY7a8Uk {

    font-family: Noto Sans;

    font-size: 0.875rem;

    line-height: 1.25rem;

    font-weight: 400;

    --tw-text-opacity: 1;

    color: rgb(149 149 149 / var(--tw-text-opacity, 1))
}

.sypYVYVvfmnhXdtDoTy5 {

    margin-top: 1.25rem;

    display: flex;

    width: 100%;

    justify-content: space-between;

    font-family: Noto Sans
}

.DGBfNzfueNBrz0E8Ze4F {

    font-family: Noto Sans;

    font-size: 0.875rem;

    line-height: 1.25rem;

    font-weight: 500
}

.rSXMHRCbeKy_Oc_EdUQe {

    width: 70px;

    cursor: pointer;

    border-radius: 1.5rem;

    border-style: none;

    --tw-bg-opacity: 1;

    background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));

    padding: 6px;

    text-align: center;

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.pwSV8SuDzJ5QuWrVP7TQ {

    width: 70px;

    cursor: pointer;

    border-radius: 1.5rem;

    border-style: none;

    --tw-bg-opacity: 1;

    background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));

    padding: 6px;

    text-align: center;

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
.ciIKM7gSn8uqGXrNdnL4 .ant-tag-close-icon {

    --tw-text-opacity: 1 !important;

    color: rgb(244 49 49 / var(--tw-text-opacity, 1)) !important
}

.ciIKM7gSn8uqGXrNdnL4 .ant-tag-close-icon:hover {

    --tw-text-opacity: 1 !important;

    color: rgb(244 49 49 / var(--tw-text-opacity, 1)) !important
}

.m90URBz_axQhKq8hKFi4 {

    margin: auto;

    margin-top: 0.75rem;

    display: flex;

    height: 47px;

    width: 98%;

    align-items: center;

    gap: 1rem;

    border-radius: 5px;

    --tw-bg-opacity: 1;

    background-color: rgb(255 244 203 / var(--tw-bg-opacity, 1));

    padding-left: 0.5rem;

    padding-right: 0.5rem;

    padding-top: 1rem;

    padding-bottom: 1rem
}
.nVQjVWZiqCIm0RRhURsz {

    height: 34px;

    width: 34px;

    border-radius: 5px;

    -o-object-fit: contain;

       object-fit: contain
}
.ezMuWBcyT5KGSkKuJyac {

    font-family: Noto Sans;

    font-size: 12px;

    font-weight: 500;

    --tw-text-opacity: 1;

    color: rgb(164 133 10 / var(--tw-text-opacity, 1))
}
.lkMy6a1ShMe4eCxlDQzZ {

    height: 38px;

    width: 100px !important;

    --tw-border-opacity: 1;

    border-color: rgb(3 120 209 / var(--tw-border-opacity, 1));

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));

    padding-left: 1.5rem;

    padding-right: 1.5rem;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    --tw-text-opacity: 1;

    color: rgb(3 120 209 / var(--tw-text-opacity, 1))
}
.lkMy6a1ShMe4eCxlDQzZ:hover {

    --tw-border-opacity: 1 !important;

    border-color: rgb(3 120 209 / var(--tw-border-opacity, 1)) !important;

    --tw-bg-opacity: 1 !important;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;

    --tw-text-opacity: 1 !important;

    color: rgb(3 120 209 / var(--tw-text-opacity, 1)) !important
}
.BSD8IYn4my_NJ4i0iZIB {

    height: 38px !important;

    width: 100px !important;

    --tw-bg-opacity: 1;

    background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));

    padding-left: 1.5rem;

    padding-right: 1.5rem;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
.BSD8IYn4my_NJ4i0iZIB:hover {

    --tw-bg-opacity: 1 !important;

    background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;

    --tw-text-opacity: 1 !important;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}
`, "",{"version":3,"sources":["webpack://./src/components/PriceSummaryModal/MPGSConfirmModal/MpgsConfirmModal.module.css"],"names":[],"mappings":"AACE;;IAAA,mBAAwD;;IAAxD,aAAwD;;IAAxD,YAAwD;;IAAxD,WAAwD;;IAAxD,sBAAwD;;IAAxD,YAAwD;;IAAxD;AAAwD;;AAIxD;;IAAA,aAAiE;;IAAjE,WAAiE;;IAAjE,sBAAiE;;IAAjE,YAAiE;;IAAjE,uBAAiE;;IAAjE,kBAAiE;;IAAjE,4DAAiE;;IAAjE;AAAiE;;AAIjE;;IAAA,aAAkC;;IAAlC,WAAkC;;IAAlC;AAAkC;;AAIlC;;IAAA,aAA4C;;IAA5C,WAA4C;;IAA5C,8BAA4C;;IAA5C;AAA4C;;AAI5C;;IAAA,aAAkC;;IAAlC,WAAkC;;IAAlC;AAAkC;;AAIlC;;IAAA,sBAAyC;;IAAzC,eAAyC;;IAAzC,mBAAyC;;IAAzC;AAAyC;;AAIzC;;IAAA,sBAAiD;;IAAjD,YAAiD;;IAAjD,WAAiD;;IAAjD,qBAAiD;;IAAjD,kBAAiD;;IAAjD,4DAAiD;;IAAjD;AAAiD;AAGjD;;IAAA,sBAA4D;;IAA5D,YAA4D;;IAA5D,WAA4D;;IAA5D,qBAA4D;;IAA5D,kBAA4D;;IAA5D,4DAA4D;;IAA5D;AAA4D;AAG5D;;IAAA,aAAkC;;IAAlC,WAAkC;;IAAlC;AAAkC;AAGlC;;IAAA,sBAA2C;;IAA3C,eAA2C;;IAA3C;AAA2C;AAG3C;;IAAA,eAA6E;;IAA7E,sBAA6E;;IAA7E,eAA6E;;IAA7E,gBAA6E;;IAA7E,oBAA6E;;IAA7E,iDAA6E;;IAA7E;AAA6E;AAG7E;;IAAA,kBAA2C;;IAA3C,aAA2C;;IAA3C,YAA2C;;IAA3C,WAA2C;;IAA3C;AAA2C;AAG3C;;IAAA,kBAAuB;;IAAvB;AAAuB;;AAIvB;;IAAA,aAAoD;;IAApD,WAAoD;;IAApD,mBAAoD;;IAApD,uBAAoD;;IAApD;AAAoD;;AAIpD;;IAAA,YAA2D;;IAA3D,YAA2D;;IAA3D,kBAA2D;;IAA3D,0DAA2D;;IAA3D,oBAA2D;;IAA3D,qBAA2D;;IAA3D,mBAA2D;;IAA3D,sBAA2D;;IAA3D,oBAA2D;;IAA3D;AAA2D;;AAI3D;;IAAA,6BAAgC;;IAAhC,qEAAgC;;IAAhC,+BAAgC;;IAAhC;AAAgC;;AAIhC;;IAAA,kBAA6C;;IAA7C,aAA6C;;IAA7C,YAA6C;;IAA7C,WAA6C;;IAA7C,sBAA6C;;IAA7C;AAA6C;;AAI7C;;IAAA,aAAqE;;IAArE,WAAqE;;IAArE,qBAAqE;;IAArE,kBAAqE;;IAArE,4DAAqE;;IAArE,aAAqE;;IAArE,sBAAqE;;IAArE,gDAAqE;;IAArE,6DAAqE;;IAArE;AAAqE;;AAIrE;;IAAA,sBAAuC;;IAAvC,mBAAuC;;IAAvC,oBAAuC;;IAAvC;AAAuC;;AAIvC;;IAAA,sBAAmD;;IAAnD,mBAAmD;;IAAnD,oBAAmD;;IAAnD,gBAAmD;;IAAnD,oBAAmD;;IAAnD;AAAmD;;AAInD;;IAAA,mBAAkD;;IAAlD,aAAkD;;IAAlD,WAAkD;;IAAlD,8BAAkD;;IAAlD;AAAkD;;AAIlD;;IAAA,sBAAqC;;IAArC,mBAAqC;;IAArC,oBAAqC;;IAArC;AAAqC;;AAIrC;;IAAA,WAAkG;;IAAlG,eAAkG;;IAAlG,qBAAkG;;IAAlG,kBAAkG;;IAAlG,kBAAkG;;IAAlG,0DAAkG;;IAAlG,YAAkG;;IAAlG,kBAAkG;;IAAlG,oBAAkG;;IAAlG;AAAkG;;AAIlG;;IAAA,WAAgG;;IAAhG,eAAgG;;IAAhG,qBAAgG;;IAAhG,kBAAgG;;IAAhG,kBAAgG;;IAAhG,0DAAgG;;IAAhG,YAAgG;;IAAhG,kBAAgG;;IAAhG,oBAAgG;;IAAhG;AAAgG;AAGhG;;IAAA,+BAAuB;;IAAvB;AAAuB;;AAIvB;;IAAA,+BAAuB;;IAAvB;AAAuB;;AAIvB;;IAAA,YAAoG;;IAApG,mBAAoG;;IAApG,aAAoG;;IAApG,YAAoG;;IAApG,UAAoG;;IAApG,mBAAoG;;IAApG,SAAoG;;IAApG,kBAAoG;;IAApG,kBAAoG;;IAApG,4DAAoG;;IAApG,oBAAoG;;IAApG,qBAAoG;;IAApG,iBAAoG;;IAApG;AAAoG;AAGpG;;IAAA,YAAqD;;IAArD,WAAqD;;IAArD,kBAAqD;;IAArD,sBAAqD;;OAArD;AAAqD;AAGrD;;IAAA,sBAA4E;;IAA5E,eAA4E;;IAA5E,gBAA4E;;IAA5E,oBAA4E;;IAA5E;AAA4E;AAG5E;;IAAA,YAAyE;;IAAzE,uBAAyE;;IAAzE,sBAAyE;;IAAzE,0DAAyE;;IAAzE,kBAAyE;;IAAzE,4DAAyE;;IAAzE,oBAAyE;;IAAzE,qBAAyE;;IAAzE,mBAAyE;;IAAzE,sBAAyE;;IAAzE,oBAAyE;;IAAzE;AAAyE;AAGzE;;IAAA,iCAA8C;;IAA9C,qEAA8C;;IAA9C,6BAA8C;;IAA9C,uEAA8C;;IAA9C,+BAA8C;;IAA9C;AAA8C;AAG9C;;IAAA,uBAA2D;;IAA3D,uBAA2D;;IAA3D,kBAA2D;;IAA3D,0DAA2D;;IAA3D,oBAA2D;;IAA3D,qBAA2D;;IAA3D,mBAA2D;;IAA3D,sBAA2D;;IAA3D,oBAA2D;;IAA3D;AAA2D;AAG3D;;IAAA,6BAA8B;;IAA9B,qEAA8B;;IAA9B,+BAA8B;;IAA9B;AAA8B","sourcesContent":[".mainContainer {\n  @apply w-full h-auto flex flex-col gap-5 font-inter mt-3;\n}\n\n.paymentBrakeDown {\n  @apply w-full rounded-md p-4 flex flex-col gap-3 bg-tableExpandBG;\n}\n\n.paymentBrakeDownItem {\n  @apply w-full flex justify-between;\n}\n\n.paymentBrakeDownItemNetPayable {\n  @apply w-full flex justify-between font-bold;\n}\n\n.paymentDetailsWrapper {\n  @apply w-full flex justify-between;\n}\n\n.paymentDetailsHeader {\n  @apply text-base font-semibold font-inter;\n}\n\n.promotionSection {\n  @apply w-full h-auto rounded-lg bg-white p-4 mb-3;\n}\n.voucherSection {\n  @apply w-full h-auto rounded-lg bg-layoutBackground p-4 mb-3;\n}\n.promotionSectionHeader {\n  @apply w-full flex justify-between;\n}\n.promotionSectionTitle {\n  @apply text-[14px] font-semibold font-inter;\n}\n.promotionButton {\n  @apply text-primary font-bold text-[12px] cursor-pointer underline font-inter;\n}\n.promotionSectionBody {\n  @apply w-full h-auto flex items-center mt-2;\n}\n.noPromotionApplied {\n  @apply text-[12px] mt-2;\n}\n\n.buttonWrapper {\n  @apply w-full flex gap-4 items-center justify-center;\n}\n\n.proceedToPayButton {\n  @apply bg-secondary text-white px-6 py-2 w-[180px] h-[38px];\n}\n\n.proceedToPayButton:hover {\n  @apply !bg-secondary !text-white;\n}\n\n.promotionListWrapper {\n  @apply w-full h-auto mt-6 flex flex-col gap-4;\n}\n\n.promotionListItem {\n  @apply w-full h-[132px] bg-white rounded-lg p-4 shadow-2xl font-inter;\n}\n\n.promotionCode {\n  @apply text-lg font-semibold font-inter;\n}\n\n.promotionRemarks {\n  @apply text-sm font-normal text-gray-300 font-inter;\n}\n\n.promotionBottomRow {\n  @apply w-full mt-5 flex justify-between font-inter;\n}\n\n.promotionValidity {\n  @apply text-sm font-medium font-inter;\n}\n\n.promotionApplyButton {\n  @apply w-[70px] bg-secondary border-none rounded-3xl text-white text-center p-[6px] cursor-pointer;\n}\n\n.promotionRemoveButton {\n  @apply w-[70px] bg-red-600 border-none rounded-3xl text-white text-center p-[6px] cursor-pointer;\n}\n.customTag :global(.ant-tag-close-icon) {\n  @apply !text-danger-100;\n}\n\n.customTag :global(.ant-tag-close-icon:hover) {\n  @apply !text-danger-100;\n}\n\n.wrapperDetails {\n  @apply bg-warningCardBG h-[47px] w-[98%] m-auto mt-3 px-2 rounded-[5px] items-center flex gap-4 py-4;\n}\n.icon {\n  @apply w-[34px] h-[34px] object-contain rounded-[5px];\n}\n.sectionTitle {\n  @apply text-warningTextColor font-dashboardMain text-dashboardSub font-inter;\n}\n.cancel {\n  @apply bg-white text-primary border-primary px-6 py-2 !w-[100px] h-[38px];\n}\n.cancel:hover {\n  @apply !bg-white !text-primary !border-primary;\n}\n.confirm {\n  @apply bg-primary text-white px-6 py-2 !w-[100px] !h-[38px];\n}\n.confirm:hover {\n  @apply !bg-primary !text-white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `aYoRFL5C7gocBQg0JmTs`,
	"paymentBrakeDown": `Ida6mZxvJvkKDdzGsDTl`,
	"paymentBrakeDownItem": `m9jTYkAItI0R3dU3fS6G`,
	"paymentBrakeDownItemNetPayable": `bmKQY5awTkVxI80Zu8VV`,
	"paymentDetailsWrapper": `L5cr5aRDE8NYP_QQxkcx`,
	"paymentDetailsHeader": `wlnrCc3wcG8WItPDKjzz`,
	"promotionSection": `eQh_KBPSRVJDMA1wr4bE`,
	"voucherSection": `pCt8gVJchyqDAMdyX1kq`,
	"promotionSectionHeader": `MUJy4XmvKUhygJ6iLTzF`,
	"promotionSectionTitle": `iyayL373quYP3YslNWI6`,
	"promotionButton": `ywNJQVILqqkh68CPccRw`,
	"promotionSectionBody": `nouZNe_v1gyilK5zOPhD`,
	"noPromotionApplied": `RvHPUPYhgpKk4WlIe6GY`,
	"buttonWrapper": `SRaMHY09hKwjguq7dhk6`,
	"proceedToPayButton": `jAOe8I01FsTd0uc0mTno`,
	"promotionListWrapper": `A2oeKMjFCuN9sRNS1FWK`,
	"promotionListItem": `uE8FmmiJZW0UscC4o2ak`,
	"promotionCode": `dNbE7FPgr0dyL02Spilg`,
	"promotionRemarks": `qsbAhlD5PeP6MgY7a8Uk`,
	"promotionBottomRow": `sypYVYVvfmnhXdtDoTy5`,
	"promotionValidity": `DGBfNzfueNBrz0E8Ze4F`,
	"promotionApplyButton": `rSXMHRCbeKy_Oc_EdUQe`,
	"promotionRemoveButton": `pwSV8SuDzJ5QuWrVP7TQ`,
	"customTag": `ciIKM7gSn8uqGXrNdnL4`,
	"wrapperDetails": `m90URBz_axQhKq8hKFi4`,
	"icon": `nVQjVWZiqCIm0RRhURsz`,
	"sectionTitle": `ezMuWBcyT5KGSkKuJyac`,
	"cancel": `lkMy6a1ShMe4eCxlDQzZ`,
	"confirm": `BSD8IYn4my_NJ4i0iZIB`
};
export default ___CSS_LOADER_EXPORT___;
